import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { actionCreators } from "./redux/sagas/utilization/utilization";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import Heatmap from "./smartComponents/chart";
import YearOverYear from "./smartComponents/yearOverYear";
import FilterByClass from "./smartComponents/filterByClass";
import FilterByStaff from "./smartComponents/filterByStaff";
import DatePicker from "./smartComponents/datePicker";
import CustomDateRanges from "./smartComponents/customDateRanges";
import FilterByCategory from "./smartComponents/filterByCategory";
import PeriodType from "./smartComponents/periodType";
import { DataPoints } from "./smartComponents/dataPoints";
import ToggleableButton from "../../../components/toggleableButton/toggleableButton";
import { addSticky } from "../../../utils/addSticky";
import UtilizationLearnMore from "./smartComponents/utilizationLearnMore";
import FilterByBookingStatus from "./smartComponents/filterByBookingStatus";
import { Averages } from "./smartComponents/averages";
import { SubAverageFilter } from "./smartComponents/subAverageFilter";

export class UtilizationModule extends React.Component {
  constructor(props) {
    super(props);
    this.resetData = this.resetData.bind(this);
    this.state = {
      filtersDirty: false,
      stickyAdded: false
    };
    this.contentRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchCurrentUser({
      currentUser: this.props.currentUser,
      numberOfMonths: this.props.numberOfMonths
    });
  }

  componentDidUpdate() {
    if (!this.props.isLoading) {
      addSticky();
    }
  }

  resetData() {
    this.props.fetchCurrentUser({
      currentUser: this.props.currentUser,
      numberOfMonths: this.props.numberOfMonths
    });

    this.setState({
      filtersDirty: false
    });
  }

  renderUpdateBtn() {
    if (
      this.props.filtersDirty &&
      !this.props.isLoading &&
      this.props.startDate !== "Invalid date" &&
      this.props.endDate !== "Invalid date" &&
      !this.props.classFiltersLoading &&
      !this.props.staffFiltersLoading
    ) {
      return (
        <button
          className="submit"
          onClick={() => this.props.updateChart()}
          disabled={
            this.props.selectedClassFiltersLength == 0 || this.props.selectedStaffFiltersLength == 0
          }
        >
          Update
        </button>
      );
    }

    return null;
  }

  renderResetBtn() {
    if (
      this.props.filtersDirty &
      !this.props.isLoading &
      !this.props.classFiltersLoading &
      !this.props.staffFiltersLoading
    ) {
      return (
        <button className="submit reset" onClick={() => this.resetData()}>
          Reset
        </button>
      );
    }

    return null;
  }

  render() {
    const updateButton = this.renderUpdateBtn();
    const resetButton = this.renderResetBtn();
    const averageNotSet = !this.props.average || this.props.average == "Not selected";
    const allSites = this.props.userParams.current_location_id === -1;

    return (
      <div className="utilization-module">
        <SectionToggle
          maxHeight="auto"
          autoHeight
          title="Class Utilization"
          customClass="class-utilization-heatmap withSticky"
          hideToggle
          isLoading={this.props.isLoading}
          learnMore={<UtilizationLearnMore sourceType={this.props.sourceType} />}
          content={
            <div>
              <div className="edit-selections-bar" id="sticky-select-bar">
                <div className="selection-bar-filters">
                  <div className="dates-container">
                    <div className="select-box-no-width date-range-select-box">
                      <p className="offers-title">Date Range</p>
                      {!this.state.filtersDirty && <CustomDateRanges />}
                    </div>
                    <div className="date-select-box select-box multi" style={{ width: "286px" }}>
                      <p className="offers-title">Date</p>
                      {!this.state.filtersDirty && <DatePicker />}
                    </div>
                  </div>
                  <div></div>
                  <div className="filters-container">
                    <div className="select-box" style={{ width: "200px" }}>
                      <p className="offers-title">Category</p>
                      <FilterByCategory />
                    </div>

                    <div className="select-box" style={{ width: "200px" }}>
                      <p className="offers-title">Booking Status</p>
                      <FilterByBookingStatus />
                    </div>

                    <Averages />

                    {this.props.subAverageFilterOptions[this.props.average]?.length ? (
                      <div className="select-box" style={{ width: "150px" }}>
                        <p className="offers-title">{this.props.average}</p>
                        <SubAverageFilter />
                      </div>
                    ) : null}

                    {averageNotSet ? (
                      <div className="select-box" style={{ width: "200px" }}>
                        <p className="offers-title">Class</p>
                        {!this.props.classFiltersLoading ? (
                          <FilterByClass />
                        ) : (
                          <button className="picky__input">
                            <LoadingAnimation uiLoader />
                          </button>
                        )}
                      </div>
                    ) : null}

                    {averageNotSet &&
                    (!allSites ||
                      (allSites && this.props.userParams.filters.locations.length <= 50)) ? (
                      <div className="select-box" style={{ width: "200px" }}>
                        <p className="offers-title">Staff</p>
                        {!this.props.staffFiltersLoading ? (
                          <FilterByStaff />
                        ) : (
                          <button className="picky__input">
                            <LoadingAnimation uiLoader />
                          </button>
                        )}
                      </div>
                    ) : null}

                    {updateButton || resetButton ? (
                      <div className="action-buttons">
                        {updateButton}
                        {resetButton}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              {this.props.series.length !== 0 ? (
                <>
                  {this.props.updatesLoading ? (
                    <LoadingAnimation />
                  ) : (
                    <div className="content-wrapper">
                      <DataPoints />

                      <div className="chart-header">
                        <h2>Total {this.props.currentSelectedCategory} Breakdown</h2>
                        <div className="select-box" style={{ width: "200px" }}>
                          {this.props.yearOverYearLoading ? (
                            <button className="picky__input">
                              <LoadingAnimation uiLoader />{" "}
                            </button>
                          ) : (
                            <PeriodType />
                          )}
                        </div>
                      </div>
                      <YearOverYear
                        margin={{ top: 5, right: 60, left: 5, bottom: 5 }}
                        cartesianGridVerticalPoints={(width) => [width - 60]} // To place the vertical line at the right we need the width minus margin-right
                      />
                    </div>
                  )}

                  <div style={{ paddingTop: "50px" }}>
                    <h2>{this.props.currentSelectedCategory} Heatmap</h2>
                    {this.props.sourceType !== "marianatek" ? (
                      <div className="utilization-toggle">
                        <p>Group by Day of the Week</p>
                        <ToggleableButton
                          title="Group by Day of the Week V2"
                          isRadio
                          isActive={this.props.groupByWeekDay}
                          onClick={(isActive) => this.props.onChangeToggle(isActive)}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    {this.props.updatesLoading ? <LoadingAnimation /> : <Heatmap />}
                  </div>
                </>
              ) : (
                <p className="error">No data found, please update filters and try again.</p>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.utilization.isLoading,
    userParams: state.utilization.currentUser,
    updatesLoading: state.utilization.updatesLoading,
    series: state.utilization.series,
    filtersDirty: state.utilization.filtersDirty,
    classFiltersLoading: state.utilization.classFiltersLoading,
    staffFiltersLoading: state.utilization.staffFiltersLoading,
    selectedClassFiltersLength: state.utilization.selectedClassFilters.length,
    selectedStaffFiltersLength: state.utilization.selectedStaffFilters.length,
    startDate: state.utilization.startDate,
    endDate: state.utilization.endDate,
    customDateRangeLoading: state.utilization.customDateRangeLoading,
    yearOverYearLoading: state.utilization.yearOverYearLoading,
    currentSelectedCategory: state.utilization.currentSelectedCategory,
    groupByWeekDay: state.utilization.groupByWeekDay,
    sourceType: state.utilization.currentUser.sourceType,
    average: state.utilization.average,
    subAverageFilterOptions: state.utilization.subAverageFilterOptions
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateChart: actionCreators.updateData,
    onChangeToggle: actionCreators.onChangeToggle
  }
)(UtilizationModule);

UtilizationModule.propTypes = {
  currentUser: PropTypes.object,
  fetchCurrentUser: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  series: PropTypes.array,
  filtersDirty: PropTypes.bool,
  updateChart: PropTypes.func,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  classFiltersLoading: PropTypes.bool,
  staffFiltersLoading: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  yearOverYearLoading: PropTypes.bool,
  updatesLoading: PropTypes.bool,
  currentSelectedCategory: PropTypes.string,
  groupByWeekDay: PropTypes.bool,
  onChangeToggle: PropTypes.func,
  selectedClassFiltersLength: PropTypes.number,
  selectedStaffFiltersLength: PropTypes.number,
  sourceType: PropTypes.string
};
